import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import Model from 'flarum/common/Model';
import PostStream from 'flarum/forum/components/PostStream';
import Discussion from 'flarum/common/models/Discussion';
import MatchRatingComponent from './match-rating/MatchRatingComponent';
import MatchInjectedContent from './match-rating/MatchInjectedContent';
import BolillaWidget from './bolilla/BolillaWidget';
import MatchStatsPage from './match-rating/MatchStatsPage';
import LineupClassificationPage from './lineup/LineupClassificationPage';
import Player from '../common/models/Player';
import Match from '../common/models/Match';
import MatchVote from '../common/models/MatchVote';
import Team from '../common/models/Team';
import Season from '../common/models/Season';
import LineupScore from '../common/models/LineupScore';
import extendMatchRatingAdmin from './match-rating/extendMatchRatingAdmin';
import extendLineupRenderer from './lineup/extendLineupRenderer';
import extendPostDesign from './forum/extendPostDesign';
import extendMobileNavigation from './forum/extendMobileNavigation';
import fixIOSWebKitComposer from './forum/fixIOSWebKitComposer';
import extendDuplicatePrevention from './duplicates/extendDuplicatePrevention';
import addSlashCommandsAutocomplete from './addSlashCommandsAutocomplete';
import addRegistrationSecurityQuestion from './lineup/addRegistrationSecurityQuestion';
import JavertFormatModal from './format-assistant/JavertFormatModal';
import PostControls from 'flarum/forum/utils/PostControls';
import AchievementsPage from './achievements/AchievementsPage';
import CharacterSheetPage from './character-sheet/CharacterSheetPage';
import UserStatsPage from './user-stats/UserStatsPage';
import SettingsPage from 'flarum/forum/components/SettingsPage';
import NotificationGrid from 'flarum/forum/components/NotificationGrid';
import Switch from 'flarum/common/components/Switch';
import AchievementAwardedNotification from './achievements/AchievementAwardedNotification';
import BolillaReminderNotification from './bolilla/BolillaReminderNotification';
import LineupReminderNotification from './lineup/LineupReminderNotification';
import CustomNotificationNotification from './notifications/CustomNotificationNotification';
import MatchInfoNotification from './notifications/MatchInfoNotification';
import PostUser from 'flarum/forum/components/PostUser';
import UserCard from 'flarum/forum/components/UserCard';
import UserPage from 'flarum/forum/components/UserPage';
import LinkButton from 'flarum/common/components/LinkButton';
import Dropdown from 'flarum/common/components/Dropdown';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import enhanceUserDirectoryCards from './user-directory/enhanceUserDirectoryCards';
import extendTagsPage from './forum/extendTagsPage';
import icon from 'flarum/common/helpers/icon';
import abbreviateNumber from 'flarum/common/utils/abbreviateNumber';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import PaginatedListState from 'flarum/common/states/PaginatedListState';
import AvatarEditor from 'flarum/forum/components/AvatarEditor';
import BolillaVote from '../common/models/BolillaVote';
import BolillaClassification from '../common/models/BolillaClassification';
import BolillaPage from './bolilla/BolillaPage';
import AchievementsClassification from '../common/models/AchievementsClassification';
import AchievementsClassificationPage from './achievements/AchievementsClassificationPage';
import AurreraJokoakPage from './aurrera-jokoak/AurreraJokoakPage';
import PasatiemposPage from './pasatiempos/PasatiemposPage';
import UserMatchLineup from '../common/models/UserMatchLineup';
import Rival from '../common/models/Rival';
import Competition from '../common/models/Competition';
import GorbeaVote from '../common/models/GorbeaVote';
import GorbeaResult from '../common/models/GorbeaResult';
import GorbeaScore from '../common/models/GorbeaScore';
import MundialTeam from '../common/models/MundialTeam';
import MundialVote from '../common/models/MundialVote';
import MundialScore from '../common/models/MundialScore';
import TaldezainaTask from '../common/models/TaldezainaTask';
import GorbeaVotePage from './gorbea/GorbeaVotePage';
import GorbeaClassificationPage from './gorbea/GorbeaClassificationPage';
import GorbeaPronosticosPage from './gorbea/GorbeaPronosticosPage';
import LeagueStandingsPage from './gorbea/LeagueStandingsPage';
import IndexPage from 'flarum/forum/components/IndexPage';
import PageStructure from 'flarum/forum/components/PageStructure';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import extendSearch from './search/extendSearch';
import StatsPage from './stats/StatsPage';
import AdvancedAdminWidget from './stats/AdvancedAdminWidget';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import WelcomeHero from 'flarum/forum/components/WelcomeHero';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import LogInModal from 'flarum/forum/components/LogInModal';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import PostStreamScrubber from 'flarum/forum/components/PostStreamScrubber';
import Footer from './forum/Footer';
import TextEditor from 'flarum/common/components/TextEditor';
import CalendarPage from './calendar/CalendarPage';
import EmojiPicker from './custom-emojis/EmojiPicker';
import BirthdayBanner from './match-rating/BirthdayBanner';
import HelpIndexPage from './tutorials/HelpIndexPage';
import HelpSectionPage from './tutorials/HelpSectionPage';
import GuidesModal from './tutorials/GuidesModal';
import NotificationWizardModal from './tutorials/NotificationWizardModal';
import Colaboracion from '../common/models/Colaboracion';
import CommentPost from 'flarum/forum/components/CommentPost';
import SupporterClub from '../common/models/SupporterClub';
import SupporterClubsPage from './supporter-clubs/SupporterClubsPage';
import MundialVotePage from './mundial/MundialVotePage';
import MundialClassificationPage from './mundial/MundialClassificationPage';
import MundialTeamsPage from './mundial/MundialTeamsPage';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
function wrapWithTxapela(user, vnode, extraClass) {
  if (extraClass === void 0) {
    extraClass = '';
  }
  if (!user || !user.attribute('activeTxapelas') || !vnode) return vnode;
  const txapelas = user.attribute('activeTxapelas');
  if (!txapelas.aldeanos && !txapelas.bolilla && !txapelas.gorbea) return vnode;
  let txapelaType = 'classic';
  let tooltipText = '';
  let txapelaText = '';
  const activeCount = (txapelas.aldeanos ? 1 : 0) + (txapelas.bolilla ? 1 : 0) + (txapelas.gorbea ? 1 : 0);
  if (activeCount >= 3) {
    txapelaType = 'triple';
    tooltipText = '¡SUPER TXAPELDUN TRIPLE 2026!';
    txapelaText = 'TRIPLE TXAPELDUN 2026';
  } else if (activeCount === 2) {
    txapelaType = 'double';
    tooltipText = app.translator.trans('nagusi-achievements.forum.txapela.double_champion');
    txapelaText = 'SUPER TXAPELDUN 2026';
  } else if (txapelas.aldeanos) {
    txapelaType = 'aldeanos';
    tooltipText = app.translator.trans('nagusi-achievements.forum.txapela.aldeanos_champion');
    txapelaText = '11 ALDEANOS 2026';
  } else if (txapelas.bolilla) {
    txapelaType = 'bolilla';
    tooltipText = app.translator.trans('nagusi-achievements.forum.txapela.bolilla_champion');
    txapelaText = 'BOLILLA 2026';
  } else if (txapelas.gorbea) {
    txapelaType = 'gorbea';
    tooltipText = 'Campeón del Trofeo Pastor del Gorbea 2026';
    txapelaText = 'PASTOR DEL GORBEA';
  }

  // Copy positioning classes to the container to handle positioning/layouts cleanly
  let containerClasses = "Avatar-txapelaContainer txapela-type-".concat(txapelaType);
  if (extraClass) {
    containerClasses += ' ' + extraClass;
  }
  if (vnode.attrs && vnode.attrs.className) {
    const classes = vnode.attrs.className.split(' ');

    // Classes to copy to the container to handle positioning/layouts cleanly
    const transferList = ['PostUser-avatar', 'DiscussionListItem-author'];
    classes.forEach(cls => {
      if (transferList.includes(cls) && !containerClasses.includes(cls)) {
        containerClasses += ' ' + cls;
      }
    });
    vnode.attrs.className = vnode.attrs.className + ' has-txapela';
  }
  const pathId = 'txapela-path-' + Math.random().toString(36).substr(2, 9);
  return m("div", {
    className: containerClasses,
    title: tooltipText
  }, vnode, m("div", {
    className: "Avatar-txapelaDecorator"
  }, m("svg", {
    viewBox: "0 0 100 45",
    className: "txapela-svg",
    xmlns: "http://www.w3.org/2000/svg"
  }, m("defs", null, m("path", {
    id: pathId,
    d: "M 8,24 Q 50,13 92,24",
    fill: "none",
    stroke: "none"
  })), m("ellipse", {
    cx: "50",
    cy: "30",
    rx: "35",
    ry: "8",
    fill: "rgba(0, 0, 0, 0.25)"
  }), m("path", {
    d: "M 8,24 C 8,6 92,6 92,24 C 92,36 8,36 8,24 Z",
    className: "txapela-body"
  }), m("path", {
    d: "M 20,28 Q 50,34 80,28 Q 50,23 20,28 Z",
    fill: "#131314"
  }), m("path", {
    d: "M 50,11 Q 50,4 51,2 Q 53,4 53,11 Z",
    className: "txapela-body"
  }), m("text", {
    className: "txapela-text",
    dy: "1.5",
    textAnchor: "middle",
    "text-anchor": "middle"
  }, m("textPath", {
    href: "#".concat(pathId),
    startOffset: "50%",
    textAnchor: "middle",
    "text-anchor": "middle"
  }, txapelaText)))));
}
function wrapAvatarInVnode(vnode, user, extraClass) {
  if (extraClass === void 0) {
    extraClass = '';
  }
  if (!vnode) return;
  if (Array.isArray(vnode)) {
    for (let i = 0; i < vnode.length; i++) {
      const child = vnode[i];
      if (child && child.attrs && (child.attrs.className || '').includes('Avatar')) {
        if (child.attrs.className.includes('has-txapela')) continue;
        vnode[i] = wrapWithTxapela(user, child, extraClass);
        continue;
      }
      wrapAvatarInVnode(child, user, extraClass);
    }
    return;
  }
  if (vnode.children) {
    if (Array.isArray(vnode.children)) {
      wrapAvatarInVnode(vnode.children, user, extraClass);
    } else {
      const child = vnode.children;
      if (child && child.attrs && (child.attrs.className || '').includes('Avatar')) {
        if (!child.attrs.className.includes('has-txapela')) {
          vnode.children = wrapWithTxapela(user, child, extraClass);
        }
        return;
      }
      wrapAvatarInVnode(vnode.children, user, extraClass);
    }
  }
}
const getTrueUnreadCount = discussion => {
  var _discussion$lastPostN;
  if (!discussion) return 0;
  if (!discussion.isUnread()) return 0;
  const lastRead = discussion.lastReadPostNumber();
  if (!lastRead) {
    return discussion.replyCount();
  }
  return Math.max(0, ((_discussion$lastPostN = discussion.lastPostNumber()) != null ? _discussion$lastPostN : 0) - lastRead);
};
const setupReadTracker = function (component) {
  if (!app.session.user) return;
  const discussion = component.discussion;
  if (!discussion) return;
  if (component.bizkaitarraTrackingDiscussionId === discussion.id()) return;
  component.bizkaitarraTrackingDiscussionId = discussion.id();
  if (component.bizkaitarraObserver) {
    component.bizkaitarraObserver.disconnect();
  }
  component.bizkaitarraObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const currentDiscussion = component.discussion;
        if (!currentDiscussion) return;
        const lastPost = currentDiscussion.lastPostNumber() || 0;
        if (lastPost > 0 && (currentDiscussion.lastReadPostNumber() || 0) < lastPost) {
          currentDiscussion.save({
            lastReadPostNumber: lastPost
          }).then(() => {
            m.redraw();
          });
        }
      }
    });
  }, {
    threshold: 0.1
  });
  const observeFooter = () => {
    if (!component.bizkaitarraObserver) return;
    const footerEl = document.querySelector('.App-footer');
    if (footerEl) {
      component.bizkaitarraObserver.observe(footerEl);
    } else {
      setTimeout(observeFooter, 100);
    }
  };
  observeFooter();
};
const SHOW_BLOOD_DONATION = false; // Cambiar a true para alternar al llamamiento de donación de sangre

const getHeroVnode = function (isHomepage) {
  if (isHomepage === void 0) {
    isHomepage = false;
  }
  const clubSlug = app.forum && app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
  const primaryTeamName = app.forum && app.forum.attribute('nagusiMatchRatingsPrimaryTeamName') || 'Aurrera Athletic';
  const isReal = clubSlug === 'real-sociedad';
  if (typeof document !== 'undefined' && document.body) {
    document.body.classList.remove('preset-athletic', 'preset-real-sociedad');
    document.body.classList.add("preset-".concat(clubSlug));
  }

  // Secciones traducibles o fallbacks dinámicos
  const logoUrl = isReal ? '/assets/brand/reala_logo.webp' : '/assets/brand/aurrera_athletic_logo_cabecera.webp';
  const heroTitle = isReal ? 'Txuriurdin Aurrera' : 'AURRERA ATHLETIC';
  const subtitle = isReal ? 'Errealzaleen tokia' : SHOW_BLOOD_DONATION ? app.translator.trans('nagusi-match-ratings.forum.blood_donation.subtitle') : 'Athletic zaleen tokia';
  const signupText = isReal ? ' Únete a la familia txuri-urdin' : ' Únete a la familia zurigorri';
  return m('div', {
    className: "".concat(isReal ? 'erreala' : 'athletic', "-full-header")
  }, m('div', {
    className: "".concat(isReal ? 'erreala' : 'athletic', "-container")
  }, [m('div', {
    className: "".concat(isReal ? 'erreala' : 'athletic', "-logo")
  }, m(Link, {
    href: app.route('index')
  }, m('img', {
    src: logoUrl,
    alt: "".concat(primaryTeamName, " - ").concat(heroTitle)
  }))), m('div', {
    className: "".concat(isReal ? 'erreala' : 'athletic', "-text")
  }, [m(isHomepage ? 'h1' : 'span', {
    className: isHomepage ? '' : 'hero-title-fallback'
  }, [heroTitle]), m('p', subtitle), m('div', {
    className: 'header-buttons'
  }, [SHOW_BLOOD_DONATION ? m(Link, {
    className: 'Button support-button blood-donation-button',
    href: '/d/919-se-necesita-sangre-en-bizkaia'
  }, [m('i', {
    className: 'fas fa-tint',
    style: {
      color: '#e02424',
      marginRight: '8px'
    }
  }), app.translator.trans('nagusi-match-ratings.forum.blood_donation.button')]) : !app.session.user ? m('button', {
    className: 'Button Button--primary register-button',
    onclick: () => app.modal.show(SignUpModal)
  }, [m('i', {
    className: 'fas fa-user-plus'
  }), signupText]) : app.forum.attribute('nagusiMatchRatingsEnableDonations') !== false ? m(Link, {
    className: 'Button support-button',
    href: "/ayuda-aurrera-".concat(clubSlug)
  }, [m('i', {
    className: 'fas fa-hands-helping'
  }), ' Ayúdanos gratis']) : null])])]));
};
const injectHero = function (vdom) {
  if (!vdom || !vdom.children || !Array.isArray(vdom.children)) return;
  const isHomepage = this instanceof IndexPage;
  const heroVnode = getHeroVnode(isHomepage);
  const heroIndex = vdom.children.findIndex(e => e && e.tag === WelcomeHero);
  if (heroIndex !== -1) {
    vdom.children[heroIndex] = heroVnode;
  } else {
    vdom.children.unshift(heroVnode);
  }
};
const prependHero = function (vdom) {
  if (!vdom || !vdom.children || !Array.isArray(vdom.children)) return;
  const hasHero = vdom.children.some(child => child && child.attrs && child.attrs.className && String(child.attrs.className).includes('athletic-full-header'));
  if (hasHero) return;
  const isHomepage = this instanceof IndexPage;
  vdom.children.unshift(getHeroVnode(isHomepage));
};
const mountFooter = function (vdom) {
  if (!vdom || !vdom.children || !Array.isArray(vdom.children)) {
    return;
  }
  const found = vdom.children.some(child => child && child.tag === Footer);
  if (found) return;
  vdom.children.push(m(Footer));
};
const _moveEmailAlert = function () {
  const $alert = $('.Alert--emailConfirmation').closest('div');
  const $header = $('.athletic-full-header');
  if ($alert.length && $header.length) {
    $header.after($alert);
  }
};
export function getGameRedirectUrl(slug) {
  if (!slug) return null;
  const cleanSlug = String(slug).toLowerCase().trim();
  const season = app.forum && app.forum.attribute('nagusiMatchRatingsLatestSeason') || '2026-2027';
  const clubSlug = app.forum && app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
  if (cleanSlug === 'la-bolilla') {
    return "/la-bolilla/".concat(season, "/clasificacion");
  }
  if (cleanSlug === 'valoracion-de-jugadores') {
    return "/valoracion-".concat(clubSlug, "/").concat(season, "/clasificacion");
  }
  if (cleanSlug === '11-aldeanos') {
    return "/11-aldeanos/".concat(season, "/clasificacion");
  }
  return null;
}
app.initializers.add('nagusi-match-ratings', app => {
  // Intercept tag route generation for game categories preserving all route helpers (discussion, user, etc.)
  const originalRoute = app.route;
  if (typeof originalRoute === 'function') {
    app.route = new Proxy(originalRoute, {
      apply(target, thisArg, args) {
        const _args = _slicedToArray(args, 2),
          name = _args[0],
          params = _args[1];
        if (name === 'tag' && params && params.tags) {
          const gameUrl = getGameRedirectUrl(params.tags);
          if (gameUrl) return gameUrl;
        }
        return Reflect.apply(target, thisArg || app, args);
      },
      get(target, prop, receiver) {
        if (prop === 'tag') {
          const originalTagHelper = Reflect.get(target, prop, receiver);
          return function (tag) {
            const slug = typeof tag === 'string' ? tag : tag && typeof tag.slug === 'function' ? tag.slug() : null;
            const gameUrl = getGameRedirectUrl(slug);
            if (gameUrl) return gameUrl;
            return typeof originalTagHelper === 'function' ? originalTagHelper.apply(this, arguments) : '';
          };
        }
        return Reflect.get(target, prop, receiver);
      }
    });
  }
  Discussion.prototype.viewCount = Model.attribute('viewCount');
  Discussion.prototype.formattedViewCount = function () {
    const views = Number(this.viewCount()) || 0;
    if (views >= 1000000) {
      return (views / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (views >= 10000) {
      return Math.floor(views / 1000) + 'k';
    }
    if (views >= 1000) {
      return (views / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
    }
    return String(views);
  };
  extend(DiscussionListState.prototype, 'sortMap', function (map) {
    map.popular = '-view_count';
    map.unpopular = 'view_count';
  });
  extend(Discussion.prototype, 'save', function (promise, attributes) {
    if (attributes && attributes.lastReadPostNumber && this.isPrivateDiscussion && this.isPrivateDiscussion()) {
      const wasUnread = this.isUnread && this.isUnread();
      if (promise && promise.then) {
        promise.then(() => {
          if (wasUnread) {
            const user = app.session.user;
            if (user && user.unreadPrivateMessagesCount) {
              const current = user.unreadPrivateMessagesCount() || 0;
              if (current > 0) {
                user.pushAttributes({
                  unreadPrivateMessagesCount: Math.max(0, current - 1)
                });
                m.redraw();
              }
            }
          }
        });
      }
    }
  });
  extendMatchRatingAdmin(app);
  extendLineupRenderer(app);
  extendPostDesign(app);
  extendMobileNavigation(app);
  fixIOSWebKitComposer();
  extendSearch();
  extendDuplicatePrevention();
  addSlashCommandsAutocomplete();
  addRegistrationSecurityQuestion();
  app.store.models.colaborations = Colaboracion;
  app.store.models.nagusi_players = Player;
  app.store.models.nagusi_matches = Match;
  app.store.models.nagusi_competitions = Competition;
  app.store.models.nagusi_rivals = Rival;
  app.store.models.nagusi_match_votes = MatchVote;
  app.store.models.nagusi_teams = Team;
  app.store.models.nagusi_match_lineup_scores = LineupScore;
  app.store.models.nagusi_seasons = Season;
  app.store.models.nagusi_player_classification = Model;
  app.store.models.nagusi_team_matches = Match;
  app.store.models.nagusi_bolilla_votes = BolillaVote;
  app.store.models.nagusi_bolilla_classification = BolillaClassification;
  app.store.models.nagusi_achievements_classification = AchievementsClassification;
  app.store.models.nagusi_user_match_lineups = UserMatchLineup;
  app.store.models.nagusi_gorbea_votes = GorbeaVote;
  app.store.models.nagusi_gorbea_results = GorbeaResult;
  app.store.models.nagusi_gorbea_scores = GorbeaScore;
  app.store.models['supporter-clubs'] = SupporterClub;
  app.store.models.nagusi_mundial_teams = MundialTeam;
  app.store.models.nagusi_mundial_votes = MundialVote;
  app.store.models.nagusi_mundial_scores = MundialScore;
  app.store.models.nagusi_taldezaina_tasks = TaldezainaTask;
  app.routes.mundialVote = {
    path: '/mundial-2026/pronosticar',
    component: MundialVotePage
  };
  app.routes.mundialClassification = {
    path: '/mundial-2026/clasificacion',
    component: MundialClassificationPage
  };
  app.routes.mundialTeams = {
    path: '/mundial-2026/selecciones',
    component: MundialTeamsPage
  };
  app.routes.bolillaVote = {
    path: '/la-bolilla/:season/votar',
    component: BolillaPage
  };
  const clubSlug = app.forum && app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
  const setBodyPresetClass = () => {
    if (document.body) {
      document.body.classList.remove('preset-athletic', 'preset-real-sociedad');
      document.body.classList.add("preset-".concat(clubSlug));
    }
  };
  if (document.body) {
    setBodyPresetClass();
  } else {
    document.addEventListener('DOMContentLoaded', setBodyPresetClass);
  }
  app.routes['supporter-clubs.directory'] = {
    get path() {
      const slug = app.forum && app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
      return "/penas-".concat(slug, "-club");
    },
    component: SupporterClubsPage
  };
  app.routes.bolillaClassification = {
    path: '/la-bolilla/:season/clasificacion',
    component: BolillaPage
  };
  app.routes.leagueStandingsBase = {
    path: '/clasificacion',
    component: LeagueStandingsPage
  };
  app.routes.leagueStandingsSeason = {
    path: '/clasificacion/:season',
    component: LeagueStandingsPage
  };
  app.routes.leagueStandingsSeasonTeam = {
    path: '/clasificacion/:season/:team',
    component: LeagueStandingsPage
  };
  app.routes.gorbeaVote = {
    get path() {
      const slug = app.forum && app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
      const url = slug === 'real-sociedad' ? 'pastor-del-txindoki' : 'pastor-del-gorbea';
      return "/".concat(url, "/:season/pronosticar");
    },
    component: GorbeaVotePage
  };
  app.routes.gorbeaVoteRedirect = {
    get path() {
      const slug = app.forum && app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
      const url = slug === 'real-sociedad' ? 'pastor-del-txindoki' : 'pastor-del-gorbea';
      return "/".concat(url, "/:season/votar");
    },
    component: {
      oninit(vnode) {
        const slug = app.forum && app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
        const url = slug === 'real-sociedad' ? 'pastor-del-txindoki' : 'pastor-del-gorbea';
        const season = m.route.param('season') || '2025-2026';
        m.route.set("/".concat(url, "/").concat(season, "/pronosticar"), {}, {
          replace: true
        });
      },
      view() {
        return null;
      }
    }
  };
  app.routes.gorbeaClassification = {
    get path() {
      const slug = app.forum && app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
      const url = slug === 'real-sociedad' ? 'pastor-del-txindoki' : 'pastor-del-gorbea';
      return "/".concat(url, "/:season/clasificacion");
    },
    component: GorbeaClassificationPage
  };
  app.routes.gorbeaPronosticos = {
    get path() {
      const slug = app.forum && app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
      const url = slug === 'real-sociedad' ? 'pastor-del-txindoki' : 'pastor-del-gorbea';
      return "/".concat(url, "/:season/pronosticos");
    },
    component: GorbeaPronosticosPage
  };
  app.routes.matchRatingsVote = {
    get path() {
      const slug = app.forum && app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
      return "/valoracion-".concat(slug, "/:season/valorar");
    },
    component: MatchStatsPage
  };
  app.routes.matchRatingsStats = {
    get path() {
      const slug = app.forum && app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
      return "/valoracion-".concat(slug, "/:season/clasificacion");
    },
    component: MatchStatsPage
  };
  app.routes.matchRatingsClassification = {
    path: '/11-aldeanos/:season/clasificacion',
    component: LineupClassificationPage
  };
  app.routes.matchRatingsClassificationPredict = {
    path: '/11-aldeanos/:season/pronosticar',
    component: LineupClassificationPage
  };
  app.routes.achievementsClassification = {
    path: '/clasificacion-logros',
    component: AchievementsClassificationPage
  };
  app.routes.aurreraJokoak = {
    path: '/aurrera-jokoak',
    component: AurreraJokoakPage
  };
  app.routes.pasatiempos = {
    path: '/pasatiempos',
    component: PasatiemposPage
  };
  app.routes.pasatiemposGame = {
    path: '/pasatiempos/:game',
    component: PasatiemposPage
  };
  app.routes.calendarBase = {
    path: '/calendario',
    component: CalendarPage
  };
  app.routes.calendarSeason = {
    path: '/calendario/:season',
    component: CalendarPage
  };
  app.routes.calendarSeasonTeam = {
    path: '/calendario/:season/:team',
    component: CalendarPage
  };
  app.routes['advanced-admin.stats'] = {
    get path() {
      const slug = app.forum && app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
      return "/estadisticas-uso-foro-".concat(slug);
    },
    component: StatsPage
  };
  extend(IndexPage.prototype, 'view', function (vdom) {
    if (!app.forum.attribute('advancedAdminStats')) return;
    if (!vdom || !vdom.children || !Array.isArray(vdom.children)) return;

    // The 'header' extension adds Footer at the end of vdom.children. 
    // Depending on load order, Footer might already be there. Let's find it.
    const footerIndex = vdom.children.findIndex(child => child && child.tag && child.tag.name === 'Footer');
    const widgetWrapper = m("div", {
      className: "AdvancedAdminWidget-wrapper container"
    }, m(AdvancedAdminWidget, null));
    if (footerIndex !== -1) {
      // Insert just before the Footer
      vdom.children.splice(footerIndex, 0, widgetWrapper);
    } else {
      // If Footer is not yet loaded, we append it. When Footer loads, it will be placed after us.
      vdom.children.push(widgetWrapper);
    }
  });
  app.notificationComponents.achievementAwarded = AchievementAwardedNotification;
  app.notificationComponents.bolillaReminder = BolillaReminderNotification;
  app.notificationComponents.lineupReminder = LineupReminderNotification;
  app.notificationComponents.customNotification = CustomNotificationNotification;
  app.notificationComponents.matchInfoUpdated = MatchInfoNotification;
  extend(NotificationGrid.prototype, 'notificationTypes', function (items) {
    items.add('matchInfoUpdated', {
      name: 'matchInfoUpdated',
      icon: 'fas fa-calendar-alt',
      label: app.translator.trans('nagusi-match-ratings.forum.settings.notify_match_info_updated_label')
    });
    items.add('bolillaReminder', {
      name: 'bolillaReminder',
      icon: 'fas fa-futbol',
      label: app.translator.trans('nagusi-match-ratings.forum.settings.notify_bolilla_reminder_label')
    });
    items.add('lineupReminder', {
      name: 'lineupReminder',
      icon: 'fas fa-users',
      label: app.translator.trans('nagusi-match-ratings.forum.settings.notify_lineup_reminder_label')
    });
    items.add('customNotification', {
      name: 'customNotification',
      icon: 'fas fa-bullhorn',
      label: app.translator.trans('nagusi-match-ratings.forum.settings.notify_custom_notification_label')
    });
  });

  // Guard DiscussionListState against preloaded non-array documents (e.g. User pages)
  override(DiscussionListState.prototype, 'loadPage', function (original, page) {
    if (page === void 0) {
      page = 1;
    }
    const preloaded = app.preloadedApiDocument();
    if (preloaded && Array.isArray(preloaded)) {
      var _preloaded$payload;
      this.initialLoading = false;
      this.pageSize = ((_preloaded$payload = preloaded.payload) == null || (_preloaded$payload = _preloaded$payload.meta) == null ? void 0 : _preloaded$payload.perPage) || DiscussionListState.DEFAULT_PAGE_SIZE;
      return Promise.resolve(preloaded);
    }
    return PaginatedListState.prototype.loadPage.call(this, page);
  });
  app.routes.userAchievements = {
    path: '/u/:username/achievements',
    component: AchievementsPage
  };
  app.routes.userLogros = {
    path: '/u/:username/logros',
    component: AchievementsPage
  };
  app.routes.userCharacterSheet = {
    path: '/u/:username/personaje',
    component: CharacterSheetPage
  };
  app.routes.userStats = {
    path: '/u/:username/estadisticas',
    component: UserStatsPage
  };
  extend(UserPage.prototype, 'navItems', function (items) {
    items.add('character-sheet', LinkButton.component({
      href: app.route('userCharacterSheet', {
        username: this.user.username()
      }),
      icon: 'fas fa-id-card'
    }, app.translator.trans('nagusi-character-sheet.forum.nav')), 15);
    items.add('user-stats', LinkButton.component({
      href: app.route('userStats', {
        username: this.user.username()
      }),
      icon: 'fas fa-chart-pie'
    }, app.translator.trans('nagusi-user-stats.forum.nav')), 12);
    items.add('achievements', LinkButton.component({
      href: app.route('userAchievements', {
        username: this.user.username()
      }),
      icon: 'fas fa-trophy'
    }, app.translator.trans('nagusi-achievements.forum.profile.achievements_link')), 10);
  });
  extend(SettingsPage.prototype, 'privacyItems', function (items) {
    const user = this.user;
    if (!user) return;
    const isPublic = user.attribute('characterSheetPublic') !== false;
    items.add('character-sheet-privacy', Switch.component({
      state: isPublic,
      onchange: value => {
        app.request({
          method: 'PATCH',
          url: app.forum.attribute('apiUrl') + "/users/".concat(user.id(), "/character-sheet/visibility"),
          body: {
            is_public: value
          }
        }).then(res => {
          user.pushAttributes({
            characterSheetPublic: !!res.is_public
          });
          m.redraw();
        });
      }
    }, [m("strong", null, app.translator.trans('nagusi-character-sheet.forum.settings.privacy_label')), m("div", {
      className: "helpText"
    }, app.translator.trans('nagusi-character-sheet.forum.settings.privacy_help'))]), -10);
  });

  // 1. Extend PostUser view (discussion post authors)
  extend(PostUser.prototype, 'view', function (vnode) {
    const post = this.attrs.post;
    const user = post ? post.user() : null;
    if (vnode && user) {
      wrapAvatarInVnode(vnode, user, 'PostUser-avatar txapela-square-avatar');
    }
  });

  // 2. Extend DiscussionListItem (discussion author avatars in the list)
  if (DiscussionListItem.prototype.authorView) {
    override(DiscussionListItem.prototype, 'authorView', function (original) {
      const vnode = original();
      const user = this.attrs.discussion ? this.attrs.discussion.user() : null;
      if (vnode && user) {
        wrapAvatarInVnode(vnode, user);
      }
      return vnode;
    });
  } else if (DiscussionListItem.prototype.authorAvatarView) {
    override(DiscussionListItem.prototype, 'authorAvatarView', function (original) {
      const vnode = original();
      const user = this.attrs.discussion ? this.attrs.discussion.user() : null;
      if (vnode && user) {
        wrapAvatarInVnode(vnode, user);
      }
      return vnode;
    });
  }

  // 3. Override UserCard (profile headers & popup hover cards)
  override(UserCard.prototype, 'view', function (original) {
    const vnode = original();
    const user = this.attrs.user;
    if (vnode && user) {
      wrapAvatarInVnode(vnode, user);
    }
    return vnode;
  });

  // 4. Override AvatarEditor (avatar upload/remove dropdown)
  override(AvatarEditor.prototype, 'view', function (original) {
    const vnode = original();
    const user = this.attrs.user;
    if (vnode && user) {
      wrapAvatarInVnode(vnode, user);
    }
    return vnode;
  });

  // 5. Wrap the avatar helper globally in Flarum compat for third-party extensions
  const compat = window.flarum && flarum.core && flarum.core.compat ? flarum.core.compat : {};
  if (compat['common/helpers/avatar']) {
    const originalAvatar = compat['common/helpers/avatar'];
    const customAvatar = function (user, attrs) {
      const vnode = originalAvatar(user, attrs);
      return wrapWithTxapela(user, vnode);
    };
    compat['common/helpers/avatar'] = customAvatar;
    compat['helpers/avatar'] = customAvatar;
  }
  class PrivateMessagesButton extends LinkButton {
    getButtonContent(children) {
      const content = super.getButtonContent(children);
      const unread = this.attrs.unreadCount || 0;
      if (unread > 0) {
        content.splice(1, 0, m("span", {
          className: "Bubble HeaderDropdownBubble",
          "data-digits": unread > 99 ? '3' : String(unread).length
        }, unread));
      }
      return content;
    }
  }

  // Add Guides & Achievements links to Desktop Header (HeaderSecondary)
  extend(HeaderSecondary.prototype, 'items', function (items) {
    var _user$unreadPrivateMe;
    items.add('nagusi-guides-btn', m(Button, {
      className: "Button Button--flat Header-guidesBtn",
      icon: "fas fa-graduation-cap",
      onclick: () => app.modal.show(GuidesModal)
    }, app.translator.trans('nagusi-tutorials.forum.nav.guides_button') !== 'nagusi-tutorials.forum.nav.guides_button' ? app.translator.trans('nagusi-tutorials.forum.nav.guides_button') : 'Guías'), 11);
    if (!app.session.user) return;
    const user = app.session.user;
    const unreadMessagesCount = Number(((_user$unreadPrivateMe = user.unreadPrivateMessagesCount) == null ? void 0 : _user$unreadPrivateMe.call(user)) || 0);
    const messagesLabel = app.translator.trans('nagusi-match-ratings.forum.header.private_messages_title');
    items.add('byobu-private-messages', m("div", {
      className: "ButtonGroup Dropdown HeaderDropdown ByobuMessagesDropdown"
    }, m(PrivateMessagesButton, {
      href: app.route('byobuPrivate') || '/private',
      className: 'Dropdown-toggle Button Button--flat' + (unreadMessagesCount > 0 ? ' new' : ''),
      icon: "fas fa-envelope",
      unreadCount: unreadMessagesCount,
      title: messagesLabel,
      "aria-label": messagesLabel
    }, messagesLabel)), 9.8);
    items.add('nagusi-achievements-classification', m(LinkButton, {
      href: "".concat(app.forum.attribute('baseUrl'), "/u/").concat(app.session.user.username(), "/achievements"),
      icon: "fas fa-trophy",
      className: "Button Button--flat"
    }, app.translator.trans('nagusi-achievements.forum.profile.achievements_link') !== 'nagusi-achievements.forum.profile.achievements_link' ? app.translator.trans('nagusi-achievements.forum.profile.achievements_link') : 'Logros'), 9);
  });

  // Add Guides & Achievements links to Mobile Side Menu (IndexPage / IndexSidebar)
  const NavComponent = IndexSidebar || IndexPage;
  extend(NavComponent.prototype, 'navItems', function (items) {
    items.add('nagusi-guides-nav', m(Button, {
      icon: "fas fa-graduation-cap",
      onclick: () => app.modal.show(GuidesModal)
    }, app.translator.trans('nagusi-tutorials.forum.nav.guides_title') !== 'nagusi-tutorials.forum.nav.guides_title' ? app.translator.trans('nagusi-tutorials.forum.nav.guides_title') : 'Guías y Asistentes'), -98);
    if (!app.session.user) return;
    items.add('nagusi-achievements-classification', m(LinkButton, {
      href: app.route('userAchievements', {
        username: app.session.user.username()
      }),
      icon: "fas fa-trophy"
    }, app.translator.trans('nagusi-achievements.forum.profile.achievements_link') !== 'nagusi-achievements.forum.profile.achievements_link' ? app.translator.trans('nagusi-achievements.forum.profile.achievements_link') : 'Logros'), -99);
  });

  // Header initialization hooks
  extend(DiscussionPage.prototype, 'oncreate', function () {
    setupReadTracker(this);
  });
  extend(DiscussionPage.prototype, 'onupdate', function () {
    setupReadTracker(this);
  });
  extend(DiscussionPage.prototype, 'onremove', function () {
    if (this.bizkaitarraObserver) {
      this.bizkaitarraObserver.disconnect();
      this.bizkaitarraObserver = null;
    }
  });
  extend(DiscussionListItem.prototype, 'oninit', function () {
    this.subtree.check(() => this.attrs.discussion.lastReadPostNumber());
    this.subtree.check(() => getTrueUnreadCount(this.attrs.discussion));
  });
  DiscussionListItem.prototype.showRepliesCount = function () {
    return true;
  };
  DiscussionListItem.prototype.replyCountItem = function () {
    const discussion = this.attrs.discussion;
    const unreadCount = getTrueUnreadCount(discussion);
    const hasUnread = unreadCount > 0;
    const replyCount = discussion.replyCount();
    const content = [m('span', {
      className: 'DiscussionListItem-stats-item-icon'
    }, icon(hasUnread ? 'fas fa-comment-dots' : 'fas fa-comment')), m('span', {
      className: 'DiscussionListItem-stats-item-label'
    }, [m('span', {
      className: 'DiscussionListItem-total-count'
    }, abbreviateNumber(replyCount)), hasUnread ? m('span', {
      className: 'DiscussionListItem-unread-parenthesis'
    }, " (".concat(abbreviateNumber(unreadCount), ")")) : null, m('span', {
      className: 'visually-hidden'
    }, hasUnread ? "".concat(replyCount, " respuestas, ").concat(unreadCount, " no le\xEDdas") : "".concat(replyCount, " respuestas"))])];
    if (hasUnread) {
      return m('button', {
        className: 'DiscussionListItem-stats-item DiscussionListItem-count DiscussionListItem-has-unread Button--ua-reset',
        title: "".concat(replyCount, " respuestas (").concat(unreadCount, " no le\xEDdas - clic para marcar como le\xEDdo)"),
        onclick: e => {
          e.stopPropagation();
          this.markAsRead();
        }
      }, content);
    }
    return m('span', {
      className: 'DiscussionListItem-stats-item DiscussionListItem-count',
      title: "".concat(replyCount, " respuestas")
    }, content);
  };
  extend(DiscussionListItem.prototype, 'statsItems', function (items) {
    const discussion = this.attrs.discussion;
    if (discussion.formattedViewCount && typeof discussion.formattedViewCount === 'function') {
      var _discussion$viewCount;
      const rawViews = Number((_discussion$viewCount = discussion.viewCount) == null ? void 0 : _discussion$viewCount.call(discussion)) || 0;
      const formattedViews = discussion.formattedViewCount();
      items.add('discussion-views', m('span', {
        className: 'DiscussionListItem-stats-item DiscussionListItem-views',
        title: "".concat(rawViews.toLocaleString('es-ES'), " visualizaciones")
      }, [m('span', {
        className: 'DiscussionListItem-stats-item-icon'
      }, icon('fas fa-eye')), m('span', {
        className: 'DiscussionListItem-stats-item-label'
      }, [m('span', {
        'aria-hidden': 'true'
      }, formattedViews)])]), 50);
    }
  });
  extend(DiscussionListItem.prototype, 'infoItems', function (items) {
    const discussion = this.attrs.discussion;
    const unreadCount = getTrueUnreadCount(discussion);
    if (unreadCount > 0) {
      items.add('unreadCount', m('span', {
        className: 'DiscussionListItem-unreadCount'
      }, unreadCount), 100);
    }
  });
  extend(PageStructure.prototype, 'mainItems', function (items) {
    const className = this.attrs.className || '';
    if (className.includes('IndexPage')) {
      const isHomepage = !(app.currentTag && app.currentTag());
      items.add('athletic-full-header', getHeroVnode(isHomepage), 150);
      if (isHomepage) {
        items.remove('hero');
      }
    } else if (className.includes('DiscussionPage') || className.includes('UserPage')) {
      items.add('athletic-full-header', getHeroVnode(false), 150);
    }
  });
  if (app.routes['pages.show'] && app.routes['pages.show'].component && app.routes['pages.show'].component.prototype) {
    extend(app.routes['pages.show'].component.prototype, 'view', prependHero);
  }
  if (app.routes['pages.home'] && app.routes['pages.home'].component && app.routes['pages.home'].component.prototype) {
    extend(app.routes['pages.home'].component.prototype, 'view', prependHero);
  }
  if (app.routes['page'] && app.routes['page'].component && app.routes['page'].component.prototype) {
    extend(app.routes['page'].component.prototype, 'view', prependHero);
  }
  extend(IndexPage.prototype, 'view', mountFooter);
  extend(DiscussionPage.prototype, 'view', mountFooter);
  extend(UserPage.prototype, 'view', mountFooter);
  extend(IndexPage.prototype, 'oncreate', _moveEmailAlert);
  extend(DiscussionPage.prototype, 'oncreate', _moveEmailAlert);
  extend(UserPage.prototype, 'oncreate', _moveEmailAlert);
  ['nagusi.tutorials.ayuda', 'nagusi.tutorials.ayuda.section', 'aurreraJokoak', 'leagueStandingsBase', 'leagueStandingsSeason', 'leagueStandingsSeasonTeam', 'matchRatingsStats', 'matchRatingsClassification', 'matchRatingsClassificationPredict', 'bolillaClassification', 'bolillaVote', 'achievementsClassification', 'mundialVote', 'mundialClassification', 'mundialTeams', 'gorbeaClassification', 'gorbeaVote', 'gorbeaVoteRedirect', 'gorbeaPronosticos', 'calendarBase', 'calendarSeason', 'calendarSeasonTeam', 'supporter-clubs.directory', 'bizkaitarra-lineup.birthday', 'bizkaitarra-lineup.players', 'bizkaitarra-lineup.player-profile', 'bizkaitarra-lineup.player-profile-alt', 'bizkaitarra-lineup.taldezaina', 'bizkaitarra-lineup.taldezaina.players', 'bizkaitarra-lineup.taldezaina.gorbea', 'bizkaitarra-lineup.taldezaina.mundial', 'bizkaitarra-lineup.players.edit', 'bizkaitarra-lineup.matches', 'bizkaitarra-lineup.matches.create', 'bizkaitarra-lineup.matches.edit', 'bizkaitarra-lineup.matches.edit-score', 'bizkaitarra-lineup.matches.edit-participantes', 'bizkaitarra-lineup.rivals', 'bizkaitarra-lineup.rivals.create', 'bizkaitarra-lineup.rivals.edit', 'bizkaitarra-lineup.rivals.escudos'].forEach(routeName => {
    if (app.routes[routeName]) {
      const component = app.routes[routeName].component;
      const PageComponent = typeof component === 'function' ? component : component && component.prototype ? component : null;
      if (PageComponent && PageComponent.prototype) {
        extend(PageComponent.prototype, 'view', mountFooter);
        extend(PageComponent.prototype, 'oncreate', _moveEmailAlert);
      }
    }
  });
  if (app.routes['fof_user_directory'] && app.routes['fof_user_directory'].component && app.routes['fof_user_directory'].component.prototype) {
    const UserDirectoryPage = app.routes['fof_user_directory'].component;
    extend(UserDirectoryPage.prototype, 'view', prependHero);
    extend(UserDirectoryPage.prototype, 'view', mountFooter);
    extend(UserDirectoryPage.prototype, 'oncreate', _moveEmailAlert);
  }
  extend('flarum/forum/components/PostStreamScrubber', 'view', function (vdom) {
    if (!vdom || !vdom.children || !vdom.children[1]) return;
    if (!vdom.children[1] || !vdom.children[1].children || !vdom.children[1].children[0]) return;
    const scrubberDiv = vdom.children[1].children[0];
    if (scrubberDiv.attrs && scrubberDiv.attrs.className === 'Scrubber' && this.stream) {
      const count = this.stream.count();
      const numPages = Math.ceil(count / 20);
      if (numPages > 1) {
        const pages = [];
        const currentIndex = this.stream.index || 0;
        const currentPage = Math.floor(currentIndex / 20) + 1;
        for (let i = 1; i <= numPages; i++) {
          const isActive = i === currentPage;
          pages.push(m('a', {
            className: "Button ".concat(isActive ? 'Button--primary' : ''),
            title: "P\xE1gina ".concat(i),
            style: {
              padding: '0',
              width: '28px',
              height: '28px',
              lineHeight: '28px',
              textAlign: 'center',
              borderRadius: '4px',
              fontSize: '12px',
              fontWeight: isActive ? 'bold' : 'normal',
              backgroundColor: isActive ? 'var(--primary-color)' : 'var(--control-bg)',
              color: isActive ? '#fff' : 'var(--text-color)',
              border: 'none',
              boxShadow: isActive ? '0 2px 4px rgba(0,0,0,0.1)' : 'none',
              transition: 'all 0.2s ease-in-out'
            },
            onclick: e => {
              e.stopPropagation();
              this.stream.goToIndex((i - 1) * 20);
              this.updateScrubberValues({
                animate: true,
                forceHeightChange: true
              });
              this.$().removeClass('open');
            }
          }, i));
        }
        scrubberDiv.children.push(m('div', {
          className: 'Scrubber-pagination',
          style: {
            marginTop: '15px',
            paddingTop: '15px',
            borderTop: '1px solid var(--control-bg)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            background: 'var(--body-bg)',
            padding: '15px 10px',
            borderRadius: '0 0 8px 8px',
            boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.02)'
          }
        }, [m('div', {
          style: {
            width: '100%',
            textAlign: 'center',
            fontSize: '10px',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            fontWeight: '600',
            color: 'var(--muted-color)',
            marginBottom: '10px'
          }
        }, 'Páginas (20/pág)'), m('div', {
          style: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '5px'
          }
        }, pages)]));
      }
    }
  });
  extend(TextEditor.prototype, 'toolbarItems', function (items) {
    items.add('custom-emojis', m(EmojiPicker, {
      textEditor: this
    }), 50);

    // Add poll button to toolbar
    items.add('poll', m("button", {
      className: "Button Button--icon Button--link",
      title: app.translator.trans('fof-polls.forum.composer.add_poll'),
      onclick: () => {
        const pollButton = document.querySelector('.item-polls button') || document.querySelector('.ComposerBody-poll') || document.querySelector('[data-name="addPoll"] button');
        if (pollButton) {
          pollButton.click();
        } else {
          app.alerts.show({
            type: 'error'
          }, 'Las encuestas no están disponibles en este tipo de mensaje o no tienes permisos.');
        }
      }
    }, m("i", {
      className: "fas fa-poll"
    })), 45);
    if (items.has('preview')) {
      items.remove('preview');
    }
  });

  // Add Javert post formatting controls to the 3-dots dropdown menu (accessible to Javert, admins, and moderators)
  extend(PostControls, 'moderationControls', function (items, post) {
    var _currentUser$username;
    const currentUser = app.session.user;
    if (!currentUser || !post || post.contentType() !== 'comment') return;
    const isJavert = currentUser.id() == 7 || ((_currentUser$username = currentUser.username()) == null ? void 0 : _currentUser$username.toLowerCase()) === 'javert';
    const isAdmin = typeof currentUser.isAdmin === 'function' && currentUser.isAdmin();
    if ((isJavert || isAdmin) && post.canEdit()) {
      items.add('javert-format-post', m(Button, {
        icon: "fas fa-magic",
        onclick: () => {
          app.modal.show(JavertFormatModal, {
            post
          });
        }
      }, "Formatear"), 15);
    }
  });

  // Tutorials initialization
  app.routes['nagusi.tutorials.ayuda'] = {
    path: '/ayuda',
    component: HelpIndexPage
  };
  app.routes['nagusi.tutorials.ayuda-aurrera-athletic'] = {
    path: '/ayuda-aurrera-athletic',
    component: HelpSectionPage
  };
  app.routes['nagusi.tutorials.ayuda-aurrera-real-sociedad'] = {
    path: '/ayuda-aurrera-real-sociedad',
    component: HelpSectionPage
  };
  app.routes['nagusi.tutorials.ayuda.section'] = {
    path: '/ayuda/:slug',
    component: HelpSectionPage
  };
  extend(SessionDropdown.prototype, 'getButtonContent', function (children) {
    if (Array.isArray(children)) {
      children.push(' ', icon('fas fa-caret-down', {
        className: 'Button-caret'
      }));
    }
  });
  extend(SessionDropdown.prototype, 'items', function (items) {
    items.add('nagusi-guides-menu', m(Button, {
      icon: "fas fa-graduation-cap",
      onclick: () => app.modal.show(GuidesModal)
    }, app.translator.trans('nagusi-tutorials.forum.nav.guides_title') !== 'nagusi-tutorials.forum.nav.guides_title' ? app.translator.trans('nagusi-tutorials.forum.nav.guides_title') : 'Guías y Asistentes'), 25);
  });
  extend(SettingsPage.prototype, 'notificationsItems', function (items) {
    items.add('nagusi-notification-wizard-banner', m("div", {
      className: "NotificationWizard-settingsBanner"
    }, m("div", {
      className: "NotificationWizard-settingsBannerContent"
    }, m("i", {
      className: "fas fa-magic"
    }), m("div", null, m("strong", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.banner_settings_title') !== 'nagusi-tutorials.forum.notifications_wizard.banner_settings_title' ? app.translator.trans('nagusi-tutorials.forum.notifications_wizard.banner_settings_title') : '¿Prefieres una configuración rápida?'), m("p", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.banner_settings_text') !== 'nagusi-tutorials.forum.notifications_wizard.banner_settings_text' ? app.translator.trans('nagusi-tutorials.forum.notifications_wizard.banner_settings_text') : 'Configura tus alertas en 30 segundos con el Asistente Guiado.'))), m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-bell",
      onclick: () => app.modal.show(NotificationWizardModal)
    }, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.banner_settings_btn') !== 'nagusi-tutorials.forum.notifications_wizard.banner_settings_btn' ? app.translator.trans('nagusi-tutorials.forum.notifications_wizard.banner_settings_btn') : 'Abrir Asistente')), 100);
  });
  extend(HeaderSecondary.prototype, 'items', function (items) {
    if (!app.session.user) {
      items.remove('signUp');
      items.remove('logIn');
      items.add('nagusi-entry-dropdown', m(Dropdown, {
        className: "Header-entryDropdown",
        buttonClassName: "Button Button--flat",
        label: app.translator.trans('nagusi-match-ratings.forum.entry_dropdown_title'),
        icon: "fas fa-sign-in-alt"
      }, m(Button, {
        icon: "fas fa-sign-in-alt",
        onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'))
      }, app.translator.trans('core.forum.header.log_in_link')), app.forum.attribute('allowSignUp') !== false && m(Button, {
        icon: "fas fa-user-plus",
        onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal'))
      }, app.translator.trans('core.forum.header.sign_up_link'))), -110);
    }
    const latestSeason = app.forum.attribute('nagusiMatchRatingsLatestSeason') || '2025-2026';
    const clubSlug = app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
    const calendarTeamSlug = clubSlug === 'real-sociedad' ? 'real-sociedad' : 'athletic-club';
    const pendingTasksCount = Number(app.forum.attribute('pendingTaldezainaTasksCount') || 0);
    items.add('nagusi-community-dropdown', m(Dropdown, {
      className: "Header-communityDropdown",
      buttonClassName: "Button Button--flat",
      label: m("span", null, app.translator.trans('nagusi-match-ratings.forum.options_dropdown_title'), Boolean(app.forum.attribute('canManagePlayers')) && pendingTasksCount > 0 && m("span", {
        style: "display: inline-block; background: #e53935; color: #fff; font-size: 0.75em; font-weight: bold; border-radius: 10px; padding: 1px 7px; margin-left: 6px; vertical-align: middle;"
      }, pendingTasksCount)),
      icon: "fas fa-bars"
    }, m(LinkButton, {
      href: "/calendario/".concat(latestSeason, "/").concat(calendarTeamSlug),
      icon: "fas fa-calendar-alt"
    }, app.translator.trans('bizkaitarra-header.forum.footer.calendar_link')), m(LinkButton, {
      href: "/clasificacion/".concat(latestSeason, "/").concat(calendarTeamSlug),
      icon: "fas fa-list-ol"
    }, "Clasificaci\xF3n"), m(LinkButton, {
      href: app.route('bizkaitarra-lineup.players'),
      icon: "fas fa-users"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_directory.nav_title')), m(LinkButton, {
      href: "/aurrera-jokoak",
      icon: "fas fa-gamepad"
    }, app.translator.trans('bizkaitarra-header.forum.footer.games_link')), m(LinkButton, {
      href: "/pasatiempos",
      icon: "fas fa-puzzle-piece"
    }, "Pasatiempos"), m(LinkButton, {
      href: "/estadisticas-uso-foro-".concat(clubSlug),
      icon: "fas fa-chart-bar"
    }, app.translator.trans('bizkaitarra-header.forum.footer.stats_link')), clubSlug !== 'real-sociedad' && m(LinkButton, {
      href: "/p/vascos-por-el-mundo",
      icon: "fas fa-globe-americas"
    }, app.translator.trans('bizkaitarra-header.forum.footer.vascos_link')), app.forum.attribute('nagusiMatchRatingsEnableDonations') !== false && m(LinkButton, {
      href: "/ayuda-aurrera-".concat(clubSlug),
      icon: "fas fa-hands-helping"
    }, "Ay\xFAdanos gratis"), m(LinkButton, {
      href: app.route('nagusi.tutorials.ayuda'),
      icon: "fas fa-question-circle"
    }, app.translator.trans('nagusi-tutorials.forum.nav.help_button') !== 'nagusi-tutorials.forum.nav.help_button' ? app.translator.trans('nagusi-tutorials.forum.nav.help_button') : 'Ayuda'), Boolean(app.forum.attribute('canManagePlayers')) && m(LinkButton, {
      href: app.route('bizkaitarra-lineup.taldezaina'),
      icon: "fas fa-user-shield"
    }, app.translator.trans('bizkaitarra-lineup.forum.players.edit_players_link'), pendingTasksCount > 0 && m("span", {
      style: "display: inline-block; background: #e53935; color: #fff; font-size: 0.75em; font-weight: bold; border-radius: 10px; padding: 1px 7px; margin-left: 8px; vertical-align: middle;"
    }, pendingTasksCount))), -90);
  });
  extend(NavComponent.prototype, 'navItems', function (items) {
    items.add('nagusi-help', m(LinkButton, {
      href: app.route('nagusi.tutorials.ayuda'),
      icon: "fas fa-question-circle"
    }, app.translator.trans('nagusi-tutorials.forum.nav.help_button') !== 'nagusi-tutorials.forum.nav.help_button' ? app.translator.trans('nagusi-tutorials.forum.nav.help_button') : 'Ayuda'), -100);
  });

  // Preload data pushed by the backend for collaborations
  if (app.data.active_colaborations_tags) {
    app.store.pushPayload({
      data: app.data.active_colaborations_tags
    });
  }
  if (app.data.active_colaborations) {
    app.store.pushPayload({
      data: app.data.active_colaborations
    });
  }
  const getActiveColabs = () => app.store.all('colaborations').filter(c => c.isActive());
  const applyTagStyles = () => {
    const activeColabs = getActiveColabs();
    if (activeColabs.length === 0) return;
    activeColabs.forEach(colab => {
      const tagId = colab.tagId();
      if (tagId) {
        const selector = ".item-tag".concat(tagId);
        const tagElements = document.querySelectorAll(selector);
        tagElements.forEach(el => {
          if (!el.classList.contains("Colab--".concat(colab.colabType()))) {
            el.classList.add("Colab--".concat(colab.colabType()));
          }
        });
      }
    });
  };
  const isCollaborator = user => {
    if (!user) return false;
    if (user.isGuest && user.isGuest()) return false;
    const activeOnly = getActiveColabs();
    if (activeOnly.length === 0) return false;
    const userGroups = typeof user.groups === 'function' ? user.groups() : null;
    if (!userGroups || !Array.isArray(userGroups)) return false;
    const groupIds = userGroups.map(g => g ? String(g.id()) : 'null');
    return activeOnly.some(colab => {
      const colabGroupId = String(colab.adminGroupId());
      return groupIds.includes(colabGroupId);
    });
  };
  const getAreaRojiblancaBanner = tag => {
    return m(Link, {
      href: app.route('tag', {
        tags: tag.slug()
      }),
      className: 'featured-banner-area-rojiblanca colab-banner'
    }, [m('img', {
      src: '/assets/extensions/bizkaitarra-colaborations/area_rojiblanca_logo.png'
    }), m('div', {
      className: 'banner-content'
    }, [m('span', {
      className: 'banner-title'
    }, app.translator.trans('bizkaitarra-colaborations.forum.banner.area-rojiblanca.title')), m('span', {
      className: 'banner-subtitle'
    }, app.translator.trans('bizkaitarra-colaborations.forum.banner.area-rojiblanca.subtitle'))]), m('i', {
      className: 'fas fa-chevron-right'
    })]);
  };
  const getProyectoHadiBanner = tag => {
    return m(Link, {
      href: app.route('tag', {
        tags: tag.slug()
      }),
      className: 'featured-banner-proyecto-hadi colab-banner'
    }, [m('img', {
      src: '/assets/extensions/bizkaitarra-colaborations/proyecto_hadi_logo.webp'
    }), m('div', {
      className: 'banner-content'
    }, [m('span', {
      className: 'banner-title'
    }, app.translator.trans('bizkaitarra-colaborations.forum.banner.proyecto-hadi.title')), m('span', {
      className: 'banner-subtitle'
    }, app.translator.trans('bizkaitarra-colaborations.forum.banner.proyecto-hadi.subtitle'))]), m('i', {
      className: 'fas fa-chevron-right'
    })]);
  };
  const getAthleticInfoBanner = tag => {
    return m(Link, {
      href: app.route('tag', {
        tags: tag.slug()
      }),
      className: 'featured-banner-athletic-info colab-banner'
    }, [m('img', {
      src: '/assets/extensions/bizkaitarra-colaborations/athletic-info_logo.webp'
    }), m('div', {
      className: 'banner-content'
    }, [m('span', {
      className: 'banner-title'
    }, app.translator.trans('bizkaitarra-colaborations.forum.banner.athletic-info.title')), m('span', {
      className: 'banner-subtitle'
    }, app.translator.trans('bizkaitarra-colaborations.forum.banner.athletic-info.subtitle'))]), m('i', {
      className: 'fas fa-chevron-right'
    })]);
  };
  const DEFAULT_BANNER_ORDER = ['area-rojiblanca', 'proyecto-hadi', 'athletic-info'];
  extend(IndexPage.prototype, 'contentItems', function (items) {
    const currentTag = m.route.param('tags');
    if (currentTag) return;
    const activeColabs = getActiveColabs();
    if (activeColabs.length === 0) return;
    const withDate = activeColabs.filter(c => c.lastPostedAt() != null).sort((a, b) => b.lastPostedAt() - a.lastPostedAt());
    const usedIds = new Set(withDate.map(c => String(c.id())));
    const withoutDate = DEFAULT_BANNER_ORDER.map(type => activeColabs.find(c => c.colabType() === type && !usedIds.has(String(c.id())))).filter(Boolean);
    const orderedColabs = [...withDate, ...withoutDate].slice(0, 2);
    const banners = [];
    orderedColabs.forEach(colab => {
      const tag = app.store.getById('tags', String(colab.tagId()));
      if (!tag) return;
      let bannerVnode;
      if (colab.colabType() === 'area-rojiblanca') {
        bannerVnode = getAreaRojiblancaBanner(tag);
      } else if (colab.colabType() === 'proyecto-hadi') {
        bannerVnode = getProyectoHadiBanner(tag);
      } else if (colab.colabType() === 'athletic-info') {
        bannerVnode = getAthleticInfoBanner(tag);
      }
      if (bannerVnode) {
        banners.push({
          vnode: bannerVnode,
          type: colab.colabType()
        });
      }
    });
    if (banners.length === 0) return;
    const bannersVnodes = banners.map(b => b.vnode);
    const containerVnode = m('div', {
      className: 'colab-banners-container'
    }, bannersVnodes);
    items.add('colabBanners', containerVnode, 110);
  });

  // Inyectar banner de cumpleaños de jugadores si hay cumpleañeros hoy
  let todaysBirthdaysLoaded = false;
  let todaysBirthdaysData = [];
  const loadTodaysBirthdaysOnce = () => {
    if (todaysBirthdaysLoaded) return;
    todaysBirthdaysLoaded = true;
    app.request({
      method: 'GET',
      url: "".concat(app.forum.attribute('apiUrl'), "/nagusi/match-ratings/birthdays/today")
    }).then(res => {
      if (res && Array.isArray(res.data) && res.data.length > 0) {
        todaysBirthdaysData = res.data;
        m.redraw();
      }
    }).catch(() => {});
  };
  extend(IndexPage.prototype, 'oninit', function () {
    const currentTag = m.route.param('tags');
    const redirectUrl = getGameRedirectUrl(currentTag);
    if (redirectUrl) {
      m.route.set(redirectUrl, {}, {
        replace: true
      });
      return;
    }
    loadTodaysBirthdaysOnce();
  });
  extend(IndexPage.prototype, 'view', function (vdom) {
    if (!vdom || !vdom.children || !Array.isArray(vdom.children)) return;
    const currentTag = m.route.param('tags');
    if (currentTag) return;
    if (todaysBirthdaysData.length === 0) return;
    const birthdayBannerVnode = m(BirthdayBanner, {
      players: todaysBirthdaysData
    });
    const containerIndex = vdom.children.findIndex(e => e && e.attrs && e.attrs.className && e.attrs.className.includes('container'));
    if (containerIndex !== -1 && vdom.children[containerIndex].children) {
      const alreadyHasBanner = vdom.children[containerIndex].children.some(c => c && c.attrs && c.attrs.className && c.attrs.className.includes('BirthdayBanner-wrapper'));
      if (!alreadyHasBanner) {
        vdom.children[containerIndex].children.unshift(birthdayBannerVnode);
      }
    } else {
      const alreadyHasBanner = vdom.children.some(c => c && c.attrs && c.attrs.className && c.attrs.className.includes('BirthdayBanner-wrapper'));
      if (!alreadyHasBanner) {
        vdom.children.unshift(birthdayBannerVnode);
      }
    }
  });
  extend(NavComponent.prototype, 'navItems', function (items) {
    const activeColabs = getActiveColabs();
    if (activeColabs.length === 0) return;
    const colabTagsSet = new Set(activeColabs.map(c => String(c.tagId())));
    const colabItems = [];
    const itemDict = items.items || items._items || (items.toObject ? items.toObject() : {});
    Object.keys(itemDict).forEach(key => {
      if (key.startsWith('tag')) {
        const tagId = key.replace('tag', '');
        if (colabTagsSet.has(tagId)) {
          colabItems.push({
            key,
            item: items.get(key)
          });
        }
      }
    });
    if (colabItems.length > 0) {
      colabItems.forEach(ci => items.remove(ci.key));
      items.add('colab-heading', m('span', {
        className: 'nav-header'
      }, app.translator.trans('bizkaitarra-colaborations.forum.nav.title')), 10);
      colabItems.forEach((ci, index) => {
        items.add(ci.key, ci.item, 9 - index);
      });
      items.add('colab-end-separator', m('li', {
        className: 'Dropdown-separator'
      }), 0);
    }
  });
  extend(IndexPage.prototype, 'oncreate', applyTagStyles);
  extend(IndexPage.prototype, 'onupdate', applyTagStyles);
  const TagLinkButton = typeof flarum !== 'undefined' && flarum.reg && flarum.reg.get('flarum-tags', 'forum/components/TagLinkButton') || compat['tags/components/TagLinkButton'];
  if (TagLinkButton && TagLinkButton.prototype) {
    extend(TagLinkButton.prototype, 'view', function (vnode) {
      const tag = this.attrs.model || this.attrs.tag;
      if (!tag) return;
      const slug = typeof tag.slug === 'function' ? tag.slug() : tag.slug;
      const gameUrl = getGameRedirectUrl(slug);
      if (gameUrl && vnode && vnode.attrs) {
        vnode.attrs.href = gameUrl;
      }
      const colab = getActiveColabs().find(c => String(c.tagId()) === String(tag.id()));
      if (colab) {
        vnode.attrs.className = (vnode.attrs.className || '') + " Colab--".concat(colab.colabType());
      }
    });
  }
  extend(UserCard.prototype, 'view', function (vnode) {
    if (isCollaborator(this.attrs.user)) {
      vnode.attrs.className += ' UserCard--colaborador';
    }
  });
  extend(PostUser.prototype, 'view', function (vnode) {
    const user = this.attrs.post ? this.attrs.post.user() : null;
    if (isCollaborator(user)) {
      vnode.attrs.className += ' PostUser--colaborador';
    }
  });
  extend(CommentPost.prototype, 'classes', function (classes) {
    const user = this.attrs.post ? this.attrs.post.user() : null;
    if (isCollaborator(user)) {
      classes.push('Post--colaborador');
    }
  });
  extend(UserCard.prototype, 'infoItems', function (items) {
    const user = this.attrs.user;
    if (!user || typeof user.groups !== 'function') return;
    const userGroups = user.groups();
    if (!userGroups) return;
    const activeColabs = getActiveColabs();
    const colab = activeColabs.find(colab => userGroups.some(g => g && String(g.id()) === String(colab.adminGroupId())));
    if (colab) {
      const labelKey = colab.colabType();
      const label = app.translator.trans("bizkaitarra-colaborations.forum.user.".concat(labelKey));
      items.add('colaborador-badge', m("span", {
        className: "UserBadge UserBadge--colaborador"
      }, m("i", {
        className: "fas fa-handshake"
      }), " ", label), 100);
    }
  });
  const getColabByTagSlug = slug => {
    if (!slug) return null;
    const tag = app.store.all('tags').find(t => t.slug() === slug);
    if (!tag) return null;
    return getActiveColabs().find(c => String(c.tagId()) === String(tag.id()));
  };
  const ColaboracionTagHeader = {
    view: vnode => {
      const colab = vnode.attrs.colab;
      const ext = colab.colabType() === 'area-rojiblanca' ? 'png' : 'webp';
      const logoPath = "/assets/extensions/bizkaitarra-colaborations/".concat(colab.colabType().replace('-', '_'), "_logo.").concat(ext);
      return m("div", {
        className: "ColaboracionTagHeader ColaboracionTagHeader--".concat(colab.colabType())
      }, m("div", {
        className: "ColaboracionTagHeader-content"
      }, m("div", {
        className: "ColaboracionTagHeader-main"
      }, m("img", {
        src: logoPath,
        alt: colab.colabType(),
        className: "ColaboracionTagHeader-logo"
      }), m("div", {
        className: "ColaboracionTagHeader-info"
      }, m("h1", {
        className: "ColaboracionTagHeader-title"
      }, app.translator.trans("bizkaitarra-colaborations.forum.banner.".concat(colab.colabType(), ".title"))), colab.description() && m("div", {
        className: "ColaboracionTagHeader-description"
      }, m.trust(colab.description())), m("div", {
        className: "ColaboracionTagHeader-contact"
      }, colab.websiteUrl() && m("a", {
        href: colab.websiteUrl(),
        target: "_blank",
        className: "ColaboracionTagHeader-link",
        title: app.translator.trans('bizkaitarra-colaborations.forum.contact.web')
      }, m("i", {
        className: "fas fa-globe"
      }), " ", m("span", null, app.translator.trans('bizkaitarra-colaborations.forum.contact.web'))), colab.twitterUrl() && m("a", {
        href: colab.twitterUrl(),
        target: "_blank",
        className: "ColaboracionTagHeader-link",
        title: app.translator.trans('bizkaitarra-colaborations.forum.contact.twitter')
      }, m("i", {
        className: "fab fa-twitter"
      })), colab.facebookUrl() && m("a", {
        href: colab.facebookUrl(),
        target: "_blank",
        className: "ColaboracionTagHeader-link",
        title: app.translator.trans('bizkaitarra-colaborations.forum.contact.facebook')
      }, m("i", {
        className: "fab fa-facebook"
      })), colab.instagramUrl() && m("a", {
        href: colab.instagramUrl(),
        target: "_blank",
        className: "ColaboracionTagHeader-link",
        title: app.translator.trans('bizkaitarra-colaborations.forum.contact.instagram')
      }, m("i", {
        className: "fab fa-instagram"
      })), colab.youtubeUrl() && m("a", {
        href: colab.youtubeUrl(),
        target: "_blank",
        className: "ColaboracionTagHeader-link",
        title: app.translator.trans('bizkaitarra-colaborations.forum.contact.youtube')
      }, m("i", {
        className: "fab fa-youtube"
      })), colab.spotifyUrl() && m("a", {
        href: colab.spotifyUrl(),
        target: "_blank",
        className: "ColaboracionTagHeader-link",
        title: app.translator.trans('bizkaitarra-colaborations.forum.contact.spotify')
      }, m("i", {
        className: "fab fa-spotify"
      })), colab.whatsappUrl() && m("a", {
        href: colab.whatsappUrl(),
        target: "_blank",
        className: "ColaboracionTagHeader-link",
        title: app.translator.trans('bizkaitarra-colaborations.forum.contact.whatsapp')
      }, m("i", {
        className: "fab fa-whatsapp"
      })))))));
    }
  };
  const patchPrototype = (keyPattern, method, callback) => {
    const getAllMatches = pattern => {
      return Object.keys(compat).filter(k => k === pattern || k.endsWith('/' + pattern) || k === 'components/' + pattern);
    };
    const matches = getAllMatches(keyPattern);
    matches.forEach(key => {
      const Component = compat[key];
      if (Component && Component.prototype && Component.prototype[method]) {
        extend(Component.prototype, method, callback);
      }
    });
  };
  const injectColabHeader = function (vdom) {
    if (!vdom || !vdom.children) return vdom;
    const currentSlug = m.route.param('tags');
    if (currentSlug) {
      const colab = getColabByTagSlug(currentSlug);
      if (colab) {
        if (!Array.isArray(vdom.children)) vdom.children = [vdom.children];
        const alreadyHas = vdom.children.some(c => c && c.attrs && (c.attrs.className || '').includes('ColaboracionTagHeader'));
        if (!alreadyHas) {
          vdom.children.unshift(m(ColaboracionTagHeader, {
            colab
          }));
        }
      }
    }
    return vdom;
  };
  patchPrototype('DiscussionList', 'view', injectColabHeader);

  // Supporter Clubs Integration
  const preloadClubs = () => {
    if (app.data.supporter_clubs_tags) {
      app.store.pushPayload({
        data: app.data.supporter_clubs_tags
      });
    }
    if (app.data.supporter_clubs) {
      app.store.pushPayload({
        data: app.data.supporter_clubs
      });
    }
  };
  preloadClubs();
  const getClubByTagSlug = slug => {
    if (!slug) return null;
    const tag = app.store.all('tags').find(t => t.slug() === slug);
    if (!tag) return null;
    return app.store.all('supporter-clubs').find(club => club.isActive() && String(club.tagId()) === String(tag.id()));
  };
  const SupporterClubCardV15 = {
    view: vnode => {
      const club = vnode.attrs.club;
      if (!club) return null;
      const imgUrl = "/assets/extensions/nagusi-match-ratings/escudo/".concat(club.imagePath());
      return m('div.SupporterClub-card-container', {
        key: 'sc-card-' + club.id()
      }, [m('div.SupporterClub-card', [club.imagePath() ? m('div.SupporterClub-image-container', [m('img.SupporterClub-image', {
        src: imgUrl,
        alt: club.name()
      })]) : null, m('div.SupporterClub-info', [m('h2.SupporterClub-title', club.name()), club.foundedAt() ? m('div.SupporterClub-founded', [app.translator.trans('nagusi-match-ratings.supporter-clubs.forum.card.founded') + ' ' + new Date(club.foundedAt()).getFullYear()]) : null, m('div.SupporterClub-contact', [club.email() ? m('div', [m('i.fas.fa-envelope'), ' ', m('a', {
        href: 'mailto:' + club.email()
      }, club.email())]) : null, club.address() ? m('div', [m('i.fas.fa-map-marker-alt'), ' ', club.address()]) : null]), club.description() ? m('div.SupporterClub-description', m.trust(club.description())) : null, m('div.SupporterClub-socials', [club.websiteUrl() ? m('a.SupporterClub-social-link', {
        href: club.websiteUrl(),
        target: '_blank'
      }, m('i.fas.fa-globe')) : null, club.facebookUrl() ? m('a.SupporterClub-social-link', {
        href: club.facebookUrl(),
        target: '_blank'
      }, m('i.fab.fa-facebook')) : null, club.instagramUrl() ? m('a.SupporterClub-social-link', {
        href: club.instagramUrl(),
        target: '_blank'
      }, m('i.fab.fa-instagram')) : null, club.twitterUrl() ? m('a.SupporterClub-social-link', {
        href: club.twitterUrl(),
        target: '_blank'
      }, m('i.fab.fa-twitter')) : null])])])]);
    }
  };

  // Sidebar items Hijack V18
  patchPrototype('components/IndexPage', 'navItems', function (items) {
    const clubs = app.store.all('supporter-clubs').filter(c => c.isActive() && c.tagId());
    if (clubs.length === 0) return;
    items.add('supporter-clubs-header', m('span.nav-header', 'PEÑAS'), -101); // Priority -101 (Below help)

    const LinkButtonComponent = compat['components/LinkButton'];
    if (LinkButtonComponent && LinkButtonComponent.component) {
      items.add('supporter-clubs-directory', LinkButtonComponent.component({
        href: app.route('supporter-clubs.directory'),
        className: 'Supporter-nav-item Directory-link',
        icon: 'fas fa-list-ul'
      }, app.translator.trans('nagusi-match-ratings.supporter-clubs.forum.nav.directory')), -101.5);
    }
    clubs.forEach((club, index) => {
      const tag = app.store.getById('tags', String(club.tagId()));
      if (!tag) return;

      // REMOVE core item
      const originalId = "tag".concat(tag.id());
      if (items.has(originalId)) items.remove(originalId);
      if (LinkButtonComponent && LinkButtonComponent.component) {
        const vnode = LinkButtonComponent.component({
          href: app.route('tag', {
            tags: tag.slug()
          }),
          className: 'Supporter-nav-item Peña-item'
        }, tag.name());
        items.add("sc-tag-".concat(tag.id()), vnode, -102 - index);
      }
    });
  });

  // Content Injection V15
  const injectSupporterCardV15 = function (vdom) {
    if (!vdom || !vdom.children) return vdom;
    const currentSlug = m.route.param('tags');
    if (currentSlug) {
      const club = getClubByTagSlug(currentSlug);
      if (club) {
        if (!Array.isArray(vdom.children)) vdom.children = [vdom.children];
        const alreadyHas = vdom.children.some(c => c && c.attrs && (c.attrs.className || '').includes('SupporterClub-card-container'));
        if (!alreadyHas) {
          vdom.children.unshift(m(SupporterClubCardV15, {
            club
          }));
        }
      }
    }
    return vdom;
  };
  patchPrototype('components/DiscussionList', 'view', injectSupporterCardV15);

  // User Directory: Filter by Character Sheet
  const UserDirectoryPage = compat['fof/user-directory/forum/components/UserDirectoryPage'] || compat['components/UserDirectoryPage'] || flarum.extensions['fof-user-directory'] && flarum.extensions['fof-user-directory'].UserDirectoryPage;
  if (UserDirectoryPage) {
    extend(UserDirectoryPage.prototype, 'oninit', function () {
      var _this$params;
      if ((_this$params = this.params()) != null && (_this$params = _this$params.q) != null && _this$params.includes('is:character-sheet')) {
        this.enabledSpecialGroupFilters['character-sheet'] = 'is:character-sheet';
      }
    });
    extend(UserDirectoryPage.prototype, 'groupItems', function (items) {
      const isFiltered = this.enabledSpecialGroupFilters['character-sheet'] === 'is:character-sheet';
      const CheckableButton = compat['fof/user-directory/forum/components/CheckableButton'] || compat['components/CheckableButton'] || flarum.extensions['fof-user-directory'] && flarum.extensions['fof-user-directory'].CheckableButton || Button;
      items.add('character-sheet', CheckableButton.component({
        className: 'GroupFilterButton',
        icon: 'fas fa-id-card',
        checked: isFiltered,
        onclick: () => {
          const key = 'character-sheet';
          if (this.enabledSpecialGroupFilters[key] === 'is:character-sheet') {
            this.enabledSpecialGroupFilters[key] = '';
          } else {
            this.enabledSpecialGroupFilters[key] = 'is:character-sheet';
            this.enabledGroupFilters = [];
          }
          this.changeParams(this.params().sort);
        }
      }, app.translator.trans('nagusi-character-sheet.forum.directory.filter_has_sheet')), 85);
    });
  }

  // User Directory: Enhance Cards with Quick Actions & Clear Stats
  enhanceUserDirectoryCards(compat);

  // Tags Page: Modernized athletic sections, search, categories and rich cards
  extendTagsPage(compat);
});